var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcFileGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2675_5608",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2675_5608)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.64974 13.3249C2.28307 13.3249 1.96918 13.1943 1.70807 12.9332C1.44696 12.6721 1.31641 12.3582 1.31641 11.9915V3.99154C1.31641 3.62487 1.44696 3.31098 1.70807 3.04987C1.96918 2.78876 2.28307 2.6582 2.64974 2.6582H6.09974C6.27752 2.6582 6.44696 2.69154 6.60807 2.7582C6.76918 2.82487 6.91085 2.91931 7.03307 3.04154L7.98307 3.99154H13.3164C13.6831 3.99154 13.997 4.12209 14.2581 4.3832C14.5192 4.64431 14.6497 4.9582 14.6497 5.32487V11.9915C14.6497 12.3582 14.5192 12.6721 14.2581 12.9332C13.997 13.1943 13.6831 13.3249 13.3164 13.3249H2.64974ZM2.64974 11.9915H13.3164V5.32487H7.43307L6.09974 3.99154H2.64974V11.9915Z",
    fill: "#6B7280"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFileGrey);
export default __webpack_public_path__ + "static/media/ic_file_grey.890ad10d9375092ad2f17e9c876da2e5.svg";
export { ForwardRef as ReactComponent };